import { InfluencerCampaign } from '../../../../models/influencer-campaign';
import { NumberUtils } from '../../../utils/number.utils';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonConstant, listOrderedPlatforms } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
import { CacheService } from '../../../services/cache/cache.service';
var CampaignInfluencersItemComponent = /** @class */ (function () {
    function CampaignInfluencersItemComponent(userService, cacheService, router, route) {
        this.userService = userService;
        this.cacheService = cacheService;
        this.router = router;
        this.route = route;
        this.orderedPlatformList = [];
        this.orderedPlatformList = listOrderedPlatforms;
        this.companyId = this.userService.getCompanyId();
    }
    CampaignInfluencersItemComponent.prototype.hasPlatform = function (platformName, influencer) {
        var activePlatform = Object.getOwnPropertyDescriptor(influencer, 'campaign_influencer_platform' + platformName);
        return activePlatform ? activePlatform.value : false;
    };
    CampaignInfluencersItemComponent.prototype.normalizeNumberData = function (value) {
        if (!value) {
            return '0';
        }
        return NumberUtils.normalizeNumberToString(value);
    };
    Object.defineProperty(CampaignInfluencersItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    CampaignInfluencersItemComponent.prototype.getCountryCode = function (influencer) {
        return influencer && influencer.country.code ? influencer.country.code : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    Object.defineProperty(CampaignInfluencersItemComponent.prototype, "campaignInfluencerPost", {
        get: function () {
            if (!this.influencer || !this.influencer.campaign_influencer_number_of_post) {
                return '0';
            }
            return this.normalizeNumberData(this.influencer.campaign_influencer_number_of_post);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignInfluencersItemComponent.prototype, "campaignInfluencerReach", {
        get: function () {
            if (!this.influencer || !this.influencer.campaign_influencer_reach) {
                return '0';
            }
            return this.normalizeNumberData(this.influencer.campaign_influencer_reach.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignInfluencersItemComponent.prototype, "campaignInfluencerEngagement", {
        get: function () {
            if (!this.influencer || !this.influencer.campaign_influencer_engagement) {
                return '0';
            }
            return this.normalizeNumberData(this.influencer.campaign_influencer_engagement.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignInfluencersItemComponent.prototype, "campaignInfluencerImpact", {
        get: function () {
            if (!this.influencer || !this.influencer.campaign_influencer_engagement || !this.influencer.campaign_influencer_reach) {
                return '0';
            }
            var engagement = this.influencer.campaign_influencer_engagement.value;
            var reach = this.influencer.campaign_influencer_reach.value;
            if (!reach || reach === 0 || !engagement || engagement === 0) {
                return '0';
            }
            var impact = (engagement * 100 / reach).toFixed(0);
            return impact;
        },
        enumerable: true,
        configurable: true
    });
    CampaignInfluencersItemComponent.prototype.openInfluencerCampaign = function (influencerId, campaignInfluencerId, campaignId) {
        var backUrl = window.location.hash.substring(1, window.location.hash.indexOf('?'));
        if (influencerId && campaignInfluencerId && campaignId) {
            this.cacheService.disableCacheRemoving();
            return this.router.navigate(['influencer', influencerId, 'campaign'], {
                queryParams: {
                    campaignInfluencerId: campaignInfluencerId,
                    from_path: backUrl,
                    selectedCampaign: campaignId,
                    activeAccount: this.activeAccount
                }
            });
        }
    };
    return CampaignInfluencersItemComponent;
}());
export { CampaignInfluencersItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-influencers-item/campaign-influencers-item.component.ts.pre-build-optimizer.js